import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useNavigationBarStore = defineStore('navigationBar', () => {
  const navBarHeight = ref(0);

  const setNavBarHeight = (height: number) => {
    navBarHeight.value = height;
  };
  return {
    navBarHeight,
    setNavBarHeight,
  };
});
